import React from "react";
import {
  StyleSheet,
  View,
  StyleProp,
  ViewStyle,
  Text,
  TextStyle,
  TouchableOpacity,
} from "react-native";
import { ChevronRightIcon } from "src/components/form-control-label/components";
import { Icon, IconName } from "src/components";
import { colors } from "src/assets";

export type CallDataRowProps = {
  containerStyle?: StyleProp<ViewStyle>;
  text: string;
  textStyle?: StyleProp<TextStyle>;
  detail?: string;
  detailStyle?: StyleProp<TextStyle>;
  leftIcon?: IconName;
  rightIcon?: IconName;
  error?: string;
  onPress?: () => void;
};

export const CallDataRow: React.FC<CallDataRowProps> = ({
  containerStyle,
  text,
  textStyle,
  detail,
  detailStyle,
  leftIcon,
  rightIcon,
  error,
  onPress,
}) => {
  const content = () => {
    return (
      <React.Fragment>
        <View style={styles.content}>
          <View style={[styles.leftContainer, !detail ? { flex: 1 } : {}]}>
            {leftIcon === "chevron" ? (
              <ChevronRightIcon style={styles.leftIcon} />
            ) : null}
            {leftIcon && leftIcon !== "chevron" ? (
              <Icon
                style={styles.leftIcon}
                name={leftIcon}
                color={"#A5A5A5"}
                size={24}
              />
            ) : null}
            <Text
              style={[styles.text, textStyle, !detail ? styles.textFlex : {}]}
            >
              {text}
            </Text>
          </View>

          <View style={styles.rightContainer}>
            {detail ? (
              <Text style={[styles.detail, detailStyle]}>{detail}</Text>
            ) : null}
            {rightIcon === "chevron" ? (
              <ChevronRightIcon style={styles.rightIcon} />
            ) : null}
            {rightIcon && rightIcon !== "chevron" ? (
              <Icon
                style={styles.rightIcon}
                name={rightIcon}
                color={"#A5A5A5"}
                size={24}
              />
            ) : null}
          </View>
        </View>
        {error ? <Text style={styles.error}>{error}</Text> : null}
      </React.Fragment>
    );
  };
  return (
    <React.Fragment>
      {onPress ? (
        <TouchableOpacity
          style={[styles.container, containerStyle]}
          onPress={onPress}
        >
          {content()}
        </TouchableOpacity>
      ) : (
        <View style={[styles.container, containerStyle]}>{content()}</View>
      )}
    </React.Fragment>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingVertical: 6,
    backgroundColor: colors.chokuGray11,
    flexDirection: "column",
    borderBottomColor: colors.white,
    borderBottomWidth: 1,
  },
  content: {
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    color: colors.chokyGray10,
    fontSize: 12,
    marginRight: 16,
    width: 120,
  },
  textFlex: {
    width: 0,
    flex: 1,
  },
  leftContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  rightContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  detail: {
    color: colors.chokyGray10,
    fontSize: 14,
  },
  leftIcon: {
    marginRight: 8,
  },
  rightIcon: {
    marginLeft: "auto",
  },
  error: {
    color: colors.chokuRed,
  },
});
